/**
 * Test IDs for QA automation.
 */
export const testIds = {
  layoutRoutesCustomerPortal: "layout-routes-customer-portal",
  layoutRoutesBack: "layout-routes-back",
  layoutRoutesOpenNavigation: "layout-routes-open-navigation",
} as const;
